module.exports = __webpack_public_path__ + "img/item_img.003745f4.png";